import {activateAccount, login, resetPassword, resetPasswordConfirm, checkResetPasswordCode, logout, getStaticPage, jwtTransform} from '@/api/clientServices'
export const client = {
    state: {
        client: localStorage.getItem('client') ? JSON.parse(localStorage.getItem('client')) : {},
        staticPage: {}
    },
    getters: {
        getClient: state => state.client,
        getStaticPageContent: state => state.staticPage.content
    },
    mutations: {
        SAVE_CLIENT(state, payload) {
            let {jwt, client} = payload;
            state.client = {...client}
            localStorage.setItem('client_jwt', jwt)
            localStorage.setItem('client', JSON.stringify(client))
        },
        SAVE_STATIC_PAGE(state, payload) {
            state.staticPage = {...payload}
        },
        UNSAVE_STATIC_PAGE(state) {
            state.staticPage = {}
        },
        CLIENT_LOG_OUT (state) {
            state.client = {};
            localStorage.removeItem('client_jwt');
            localStorage.removeItem('client');
        }
    },
    actions: {
        async ACTIVATE_ACCOUNT({state}, confirm_code) {
            try {
                let data = await activateAccount(confirm_code);
                console.log(state, 'state')
                return data
            }catch(e) {
                return e.response
            }
        },
        async CLIENT_MAKE_AUTH({commit, dispatch}, data){
            try {
                let response = await login(data)
                const {jwt, client} = response.data.data;
                commit('SAVE_CLIENT', {jwt, client})
                return response;
            } catch(e) {
                dispatch('errorsHander', e.response)
            }
        },
        async CLIENT_RESET_PASSWORD({dispatch}, email){
            try {
                let response = await resetPassword(email)
                return response;
            } catch(e) {
                dispatch('errorsHander', e.response)
            }
        },
        async CLIENT_RESET_PASSWORD_CONFIRM({dispatch}, data) {
            try {
                let response = await resetPasswordConfirm(data);
                return response;
            }catch(e)  {
                dispatch('errorsHander', e.response)
            }
        },
        async CLIENT_CHECK_RESET_PASSWORD_CODE({dispatch}, code) {
            try {
                let response = await checkResetPasswordCode(code);
                return response
            }catch(e) {
                dispatch('errorsHander', e.response)
            }
        },
        async CLIENT_MAKE_LOGOUT({ commit }) {
            await logout();
            commit('CLIENT_LOG_OUT');
        },
        async CLIENT_GET_STATIC_PAGE({commit}, {page}) {
            commit('UNSAVE_STATIC_PAGE')
            commit('SET_LOADER', true);
            try {
                let response = await getStaticPage(page)
                let staticPage = response.data.data.page;
                commit('SET_LOADER', false);
                commit('SAVE_STATIC_PAGE', staticPage)
            }catch(e) {
                console.log(e.response, 'error')
            }
        },
        async CLIENT_SSO_TRANSFORM({commit}, jwt_token) {
            try {
                let response = await jwtTransform(jwt_token)
                const {jwt, client} = response.data.data;
                commit('SAVE_CLIENT', {jwt, client})
                return response;
            }catch(e) {
                console.log(e.response, 'error response')
            }
        }
    }
}